module.exports = __webpack_public_path__ + "images/Pluralsight-a52363.png";